<template>
    <div>
        <v-sheet class="px-6 pt-6" v-if="!invite_mode">
            <div class="container">
                <div class="d-flex flex-wrap justify-space-between mb-8">
                    <v-avatar size="120" class="mr-6">
                        <img
                            class=""
                            src="@/assets/images/avatars/006-woman-1.svg"
                            alt=""
                        />
                    </v-avatar>
                    <div class="flex-1">
                        <div class="d-flex align-start justify-space-between">
                            <div class="mb-3">
                                <h5 class="mr-2 mb-0">
                                    amanda_nash
                                    <v-chip
                                    class="ma-2"
                                    color="green"  
                                    dark                                  
                                    small
                                >
                                    Active
                                </v-chip>
                                </h5>
                                <span></span>                                
                                <p class="text--disabled mb-0">Amanda Nash</p>
                            </div>
                            <div>
                                
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <p class="ma-0 mr-8">
                                <span class="font-weight-medium">Admin</span
                                >
                                <!-- <span class="body-2 text--disabled"
                                    >Posts</span
                                > -->
                            </p>
                        </div>
                        <p class="text--disabled">
                            Toshiba, Siemens
                        </p>
                    </div>
                    <div class="flex-1 text-right">
                        <v-btn class="ma-2" dark color="success">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </div>
                </div>
            </div>


            <!-- <v-row justify="center">
            <v-col cols="10" md="5">
                <e-info-card
                    title="Activity and timeline"
                    sub-title="See the activity saved in your account and the places you've been. You can delete any or all your past activity."
                >
                    <template slot="basic-info-slot">
                        <v-list>
                            <v-list-item
                                v-for="item in items2"
                                :key="item.title"
                            >
                                <v-list-item-avatar>
                                    <img :src="item.icon" alt="" />
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="item.title"
                                    ></v-list-item-title>
                                    <v-list-item-subtitle
                                        v-text="item.subtitle"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </template>
                </e-info-card>
            </v-col>
        </v-row> -->

        </v-sheet>

        <!-- <v-row justify="center">
            <v-col cols="10" md="5">
                <e-info-card
                    title="Account"
                    sub-title="Authentication & Credentials"
                >
                    <template slot="basic-info-slot">
                        <v-list>
                            <v-list-item                                
                            >
                                <v-list-item-avatar>
                                    <img :src="''" alt="" />
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Title</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle
                                        v-text="'Subtitle'"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </template>
                </e-info-card>
            </v-col>
        </v-row> -->


        <v-row justify="center">
            <v-col cols="10" md="5" v-if="invite_mode">
                <e-info-card
                    title="Create User"
                    sub-title="Create a new user here. DO NOT forget to send an invitation to the user later, by clicking the 'SEND INVITATION' button within the User Edit screen."
                >
                    <template slot="basic-info-slot">
                        <v-form ref="invitationForm"  v-model="invitationFormValid">                        
                            <v-list>
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Email" 
                                            v-model="email"
                                            :rules="emailRules"      
                                            :validate-on-blur="true"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>
                                    <!-- <v-list-item-avatar>
                                        <img :src="''" alt="" />
                                    </v-list-item-avatar> -->

                                    
                                    <v-list-item-content class="pb-0">
                                        <v-text-field 
                                            label="Firstname" 
                                            v-model="firstName"    
                                            :rules="firstNameRules"
                                            :validate-on-blur="true"
                                            class="col-6 p-0 pr-4"
                                            style="padding: 0px 0px;"
                                        />
                                        <v-text-field 
                                            label="Lastname" 
                                            v-model="lastName"  
                                            :rules="lastNameRules"  
                                            :validate-on-blur="true"                          
                                            class="col-6 p-0 "
                                            style="padding: 0px 0px;"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="role"
                                            :items="roles_list_items"                 
                                            label="Role" 
                                            item-text="selecttext"
                                            item-value="selectvalue"                                             
                                            
                                            :rules="roleRules"     
                                            required                                      
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>  
                                
                                <!--<v-list-item>                                
                                    <v-list-item-content>
                                        <v-select                                                                     
                                                v-model="brand_to_add"
                                                :items="brand_list_items"                 
                                                label="Select Brand(s) to associate with this User" 
                                                item-text="selecttext"
                                                item-value="selectvalue"                                             
                                                hide-details
                                                single-line                                                                   
                                                :clearable="true"                      
                                            />
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-btn class="ma-2" dark color="primary" small @click="addSelectedBrand">
                                            <v-icon>mdi-plus</v-icon>
                                            Add
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                                <div v-if="selected_brands && selected_brands.length">
                                    <v-list-item v-for="b in selected_brands" :key="b.code">
                                        <v-list-item-avatar>
                                            <img :src="''" alt="" />
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <span >{{ b.title }}</span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ b.description }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-btn                                                
                                                dark                                                                                
                                                icon
                                                @click="removeBrand(b.code)"
                                            >
                                                <v-icon>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </div>
                                <div v-else>
                                    <v-list-item>                                
                                        <v-list-item-content class="text-center">
                                            <div class="flex-1 text-center">
                                                No Brands selected. Add one or more brands.
                                            </div>                                           
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>-->                               
                                <v-list-item>
                                    <v-list-item-content>
                                        <div class="flex-1 text-center">
                                            <v-btn 
                                            class="ma-2" dark 
                                            color="primary" style="width: 50%;"
                                            :loading="loading" @click="invite">
                                                <v-icon class="pr-2">mdi-profile</v-icon>
                                                Create User
                                            </v-btn>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>                                                   
                            </v-list>
                        </v-form>
                    </template>
                </e-info-card>
            </v-col>
            <v-col cols="10" md="5" v-if="!invite_mode">
                <e-info-card
                    title="Account"
                    sub-title="Profile & Authentication"
                >
                    <template slot="basic-info-slot">
                        <v-list>
                            <v-list-item>
                                <!-- <v-list-item-avatar>
                                    <img :src="''" alt="" />
                                </v-list-item-avatar> -->

                                
                                <v-list-item-content class="pb-0">
                                    <v-text-field 
                                        label="Firstname" 
                                        v-model="firstName"    
                                        :rules="firstNameRules"
                                        :validate-on-blur="true"
                                        class="col-6 p-0 pr-4"
                                        style="padding: 0px 0px;"
                                    />
                                    <v-text-field 
                                        label="Lastname" 
                                        v-model="lastName"  
                                        :rules="lastNameRules"  
                                        :validate-on-blur="true"                          
                                        class="col-6 p-0 "
                                        style="padding: 0px 0px;"
                                    />
                                </v-list-item-content>                                
                            </v-list-item>
                            <v-list-item>                                                               
                                <v-list-item-content class="pt-0">
                                    <v-select                                                                     
                                        v-model="role"
                                        :items="roles_list_items"                 
                                        label="Role" 
                                        item-text="selecttext"
                                        item-value="selectvalue"                                             
                                        hide-details
                                                                                                       
                                        :clearable="true"                      
                                    />
                                </v-list-item-content>                                
                            </v-list-item>
                            <v-list-item>                                                             
                                <v-list-item-content>
                                    <v-text-field 
                                        label="Email" 
                                        v-model="email"
                                        :rules="emailRules"      
                                        :validate-on-blur="true"
                                    />
                                </v-list-item-content>                                
                            </v-list-item>
                            <v-list-item>                                                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Reset Password</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Click the button to send a 'Reset Password' email to the user.
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <!-- <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn> -->
                                    <v-btn dark color="danger" small class="mr-5">
                                        Reset
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>                                                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Deactivate Account</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        User will not be able to access while deactivated
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <!-- <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn> -->
                                    <v-btn dark color="danger" small class="mr-5">
                                        Deactivate
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>                                                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Activate Account</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        User will be activated.
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <!-- <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn> -->
                                    <v-btn dark color="success" small class="mr-5">
                                        Activate
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                                

                            <!-- <v-list-item>                                
                                <v-list-item-avatar>
                                    <img :src="''" alt="" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Title</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle
                                        v-text="'Subtitle'"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item> -->
                        </v-list>
                    </template>
                </e-info-card>
            </v-col>
            <v-col cols="10" md="5" v-if="!invite_mode">
                <e-info-card
                    title="Brands"
                    sub-title="The Brands that this account is associated with"
                >
                    <template slot="basic-info-slot">
                        <v-list>
                            <v-list-item>                                
                                <v-list-item-content>
                                    <v-select                                                                     
                                            v-model="brand_to_add"
                                            :items="brand_list_items"                 
                                            label="Select a Brand" 
                                            item-text="selecttext"
                                            item-value="selectvalue"                                             
                                            hide-details
                                            single-line                                                                   
                                            :clearable="true"                      
                                        />
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn class="ma-2" dark color="primary" small>
                                        <v-icon>mdi-plus</v-icon>
                                        Add
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <img :src="''" alt="" />
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Brand Title</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Brand Description
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <img :src="''" alt="" />
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Brand Title</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Brand Description
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <img :src="''" alt="" />
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Brand Title</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Brand Description
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-information</v-icon
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </template>
                </e-info-card>
            </v-col>
            <v-col cols="10" md="5" v-if="!invite_mode">
                <e-info-card
                    title="Other Information"                    
                >
                    <template slot="basic-info-slot">
                        <v-list>                            
                            <v-list-item>                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >User Code</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        User Code
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Invitation Code</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        XYK123
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Invitation Created On</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        2015-07-01
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Activation Link</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Click the button to visit the activation link
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn class="ma-2" dark color="primary" small>                                    
                                        Visit
                                    </v-btn>
                                </v-list-item-action>                                
                            </v-list-item>
                            <v-list-item>                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Activation Date</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        2015-07-01
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <!-- <v-list-item>                                
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span >Last Password Reset</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        2015-07-01
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item> -->
                        </v-list>
                    </template>
                </e-info-card>
            </v-col>
        </v-row>
        <!-- <base-card class="transparent">
            
        </base-card> -->
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            top
            tile
            color="red accent-2"
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import avatarGroupCard from '@/components/card/AvatarGroupCard';
import EInfoCard from '@/components/card/BasicInfoCard';
import {api} from "src/api/index";
import { fieldNotEmpty, fieldMinLength } from "src/core/vuetify-validators.js"

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'User Edit'
    },
    components: {
        avatarGroupCard,
        EInfoCard
    },
    data() {
        return {
            //primary data
            email: '',
            firstName: '',
            lastName: '',
            role: '',
            brand: [],
            //ui mechanics
            invite_mode: false, 
            invitationFormValid: true,
            brand_to_add: '',
            //error
            loading: false,
            snackbar: false,
            snackbarMessage: '',
            error: '',
            //reference data
            brand_list_items: [],                                    
            roles_list_items: [
                        {
                            selectvalue: "sysadmin",
                            selecttext: "System Admin",
                        },
                        {
                            selectvalue: "admin",
                            selecttext: "Admin",
                        },
                        {
                            selectvalue: "orgadmin",
                            selecttext: "Organization Admin",
                        },
                        {
                            selectvalue: "orgviewer",
                            selecttext: "Organization Viewer",
                        },
                        {
                            selectvalue: "netviewer",
                            selecttext: "Network Viewer",
                        },
                        {
                            selectvalue: "brandleadmanager",
                            selecttext: "Brand Representative",
                        },
                        {
                            selectvalue: "brandmanager",
                            selecttext: "Brand Manager",
                        }
                    ],
            emailRules: [
                fieldNotEmpty,
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                (v) => fieldMinLength(v, 5)
            ],
            firstNameRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)   
            ],
            lastNameRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)   
            ],
            roleRules: [v => !!v || 'Item is required'],            
        }
    },
    computed: {
        selected_brands() {     
            if(this.brand && this.brand_list_items) {
                const rslt = this.brand_list_items.filter(i=> this.brand.includes(i.code));                
                if(rslt) {
                    return rslt;
                }                                           
            }                   
            return [];
        }
    },
    created() {
        if(this.$route.params.code) {
            this.crud_code = this.$route.params.code;
            this.invite_mode = false;
        }
        else {
            this.invite_mode = true;
        }
        
    },
    async mounted() {
        const rsp = await api.brand.getAll();            
        this.brand_list_items = rsp.data.map(i=> {return {...i, selectvalue: i.code, selecttext: i.title}});        
    },
    methods: {
        addSelectedBrand() {
            if(!this.brand.includes(this.brand_to_add)){
                this.brand.push(this.brand_to_add);                
            }
            this.brand_to_add = "";            
        },
        removeBrand(b){
            for(var i = 0; i < this.brand.length; i++){             
                if ( this.brand[i] === b) {             
                    this.brand.splice(i, 1); 
                }            
            }
        },
        invite() {
            this.error = '';
            this.$refs.invitationForm.validate();
            if(!this.invitationFormValid) {
                this.snackbarMessage = "There are invalid fields";
                this.snackbar = true;
                return;
            }                                
            this.loading = true;          
            api.users.invite({                
                email: this.email,                                
                firstName: this.firstName,
                lastName: this.lastName,
                role: this.role,
                brand: this.brand
            })
            .then((rsp)=>{               
                //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});  
            })
            .catch((error)=>{
                //this.error = error.response.data.message;
                this.snackbarMessage = error.response.data.message;
                this.snackbar = true;
            })
            .finally(()=>{
                this.loading = false;
            })
        }
    }
}
</script>
<style lang="scss">
.ul-widget-profile-img {
    position: relative;
}
.ul-widget-profile-img:after {
    // content: "";
    // position: absolute;
    // top: 44px;
    // left: 50%;
    // width: 1px;
    // height: calc(100% - 30px);
    // background: #B3C0CE;
    content: '';
    position: absolute;
    top: 44px;
    left: 50%;
    width: 1px;
    height: calc(100% - 30px);
    background: #b3c0ce;
}
</style>
